import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { ReplaySubject } from 'rxjs'
import { StreamTile } from 'src/app/live/models'
import { StreamTileThumbnail } from 'src/app/live/models/stream-tile-thumbnail.model'

@Component({
  selector: 'flo-stream-tile-no-sport-data',
  templateUrl: './stream-tile-no-sport-data.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreamTileNoSportDataComponent {
  public readonly streamTileThumbnailProps$ = new ReplaySubject<StreamTileThumbnail>(1)
  public readonly view$ = new ReplaySubject<StreamTile>(1)
  @Input()
  public set view(value: StreamTile) {
    this.streamTileThumbnailProps$.next({
      image: value.streamThumbnail,
      canRemove: value.canRemove,
      canAdd: value.canAdd,
      isPlaying: value.isPlaying || false,
      name: value.title
    })
    this.view$.next(value)
  }
}
